import React from 'react';

import KeyValuePairs from '../CustomFields/KeyValuePairs';

// import { AutoSaveKeyValuePairsField } from '../Component Sets/MultiPlatformComponents'

import AutoSaveField from './abstract/AutoSaveField.jsx';

class AutoSaveKeyValuePairs extends React.Component {
    constructor(props) {
        super(props);
    }

    getValueFromOnChange= ( value, someunknownBoolean ) => {
        console.log("getValueFromOnChange")
        return value;
    };

    onPersistValue = (a, b, c) => {
        console.log("onPersistValue")
    }

    render() {
        return (
            <AutoSaveField control={KeyValuePairs}
                           fieldLabel={this.props.fieldLabel}
                           name={this.props.name}
                           getValueFromOnChange={ this.getValueFromOnChange }
                           defaultValue={this.props.value}
                           value={this.props.value}
                           onPersistValue={this.onPersistValue}
                           {...this.props} />
        )
    }
}

export default AutoSaveKeyValuePairs;


// WEBPACK FOOTER //
// ./public/components/forms/AutoSaveFormFields/AutoSaveKeyValuePairs.jsx